module.exports = __webpack_public_path__ + "assets/img/dialog-banners.30835630.png";